<template>
  <Search />
</template>

<script>
import Search from '@/components/Search';
export default {
  components: {
    Search
  },
  nuxtI18n: {
    paths: {
      en: '/free-vectors/:search/p/:page',
      es: '/vectores-gratis/:search/p/:page',
      pt: '/vetores-gratis/:search/p/:page'
    }
  }
};
</script>

<style></style>
